 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER2801THEWORLDISHARDTOPREDICT from '@/components/0_chapter2801theworldishardtopredict'
 import A_CHAPTER2802BLESSEDBYMISFORTUNE from '@/components/1_chapter2802blessedbymisfortune'
 import A_CHAPTER2803SEVERHEARTMERIDIAN from '@/components/2_chapter2803severheartmeridian'
 import A_CHAPTER2804APOPLEXY from '@/components/3_chapter2804apoplexy'
 import A_CHAPTER2805YOUARENOTELIGIBLE from '@/components/4_chapter2805youarenoteligible'
 import A_CHAPTER2806WHOARETHESEANTS from '@/components/5_chapter2806whoaretheseants'
 import A_CHAPTER2807BEABLETOSTANDSTILL from '@/components/6_chapter2807beabletostandstill'
 import A_CHAPTER2808SILVERELEPHANTHAMMER from '@/components/7_chapter2808silverelephanthammer'
 import A_CHAPTER2809RESOLUTIONOFVIOLENCE from '@/components/8_chapter2809resolutionofviolence'
 import A_CHAPTER2810DONOTUNDERESTIMATE from '@/components/9_chapter2810donotunderestimate'
 import A0_CHAPTER2811CAUSALKNOT from '@/components/10_chapter2811causalknot'
 import A1_CHAPTER2812VIOLENTKILLING from '@/components/11_chapter2812violentkilling'
 import A2_CHAPTER2813KILLINGTHEDRAGONANDWOLF from '@/components/12_chapter2813killingthedragonandwolf'
 import A3_CHAPTER2814ROBBINGWHILETHEFIREISSTILLBURNING from '@/components/13_chapter2814robbingwhilethefireisstillburning'
 import A4_CHAPTER2815HEHITMEAGAINANDRANAWAY from '@/components/14_chapter2815hehitmeagainandranaway'
 import A5_CHAPTER2816THEEVILEMPERORHADCOME from '@/components/15_chapter2816theevilemperorhadcome'
 import A6_CHAPTER2817COMPLEXCOMPETITION from '@/components/16_chapter2817complexcompetition'
 import A7_CHAPTER2818HEISBRUTAL from '@/components/17_chapter2818heisbrutal'
 import A8_CHAPTER2819WHATISIT from '@/components/18_chapter2819whatisit'
 import A9_CHAPTER2820YOUARENOTELIGIBLE from '@/components/19_chapter2820youarenoteligible'
 import A0_CHAPTER2821UNABLETOJUMP from '@/components/20_chapter2821unabletojump'
 import A1_CHAPTER2822ISITBECAUSEIDISLIKEHER from '@/components/21_chapter2822isitbecauseidislikeher'
 import A2_CHAPTER2823CANTBEATDOWN from '@/components/22_chapter2823cantbeatdown'
 import A3_CHAPTER2824YOUDESERVETODIE from '@/components/23_chapter2824youdeservetodie'
 import A4_CHAPTER2825CADAVERICMETAMORPHOSIS from '@/components/24_chapter2825cadavericmetamorphosis'
 import A5_CHAPTER2826AFIGHTTOTHEDEATH from '@/components/25_chapter2826afighttothedeath'
 import A6_CHAPTER2827FULLSCALEWAR from '@/components/26_chapter2827fullscalewar'
 import A7_CHAPTER2828THESITUATIONISCLEAR from '@/components/27_chapter2828thesituationisclear'
 import A8_CHAPTER2829DOMINEERINGBEYONDLIMITS from '@/components/28_chapter2829domineeringbeyondlimits'
 import A9_CHAPTER2830TENYEARSTIME from '@/components/29_chapter2830tenyearstime'
 import A0_CHAPTER2831DONOTDARETOUNDERESTIMATE from '@/components/30_chapter2831donotdaretounderestimate'
 import A1_CHAPTER2832IMMORTALDESCENDANT from '@/components/31_chapter2832immortaldescendant'
 import A2_CHAPTER2833WHATCANYOUDO from '@/components/32_chapter2833whatcanyoudo'
 import A3_CHAPTER2834LUNARSECRETREALM from '@/components/33_chapter2834lunarsecretrealm'
 import A4_CHAPTER2835REINCARNATIONPURPLECLOUDS from '@/components/34_chapter2835reincarnationpurpleclouds'
 import A5_CHAPTER2836SITUATIONCHANGE from '@/components/35_chapter2836situationchange'
 import A6_CHAPTER2837DONEDONEDONE from '@/components/36_chapter2837donedonedone'
 import A7_CHAPTER2838AGAINTOCUTYOUDOWN from '@/components/37_chapter2838againtocutyoudown'
 import A8_CHAPTER2839THEREISAROADAHEAD from '@/components/38_chapter2839thereisaroadahead'
 import A9_CHAPTER2840PREHISTORICMAN from '@/components/39_chapter2840prehistoricman'
 import A0_CHAPTER2841VERYVIOLENT from '@/components/40_chapter2841veryviolent'
 import A1_CHAPTER2842IMGONNATAKEYOURDOGLIFE from '@/components/41_chapter2842imgonnatakeyourdoglife'
 import A2_CHAPTER2843SHEISVERYANGRY from '@/components/42_chapter2843sheisveryangry'
 import A3_CHAPTER2844UNEQUAL from '@/components/43_chapter2844unequal'
 import A4_CHAPTER2845TAKETHEINITIATIVETOSTARTAWAR from '@/components/44_chapter2845taketheinitiativetostartawar'
 import A5_CHAPTER2846SOMEOBSESSION from '@/components/45_chapter2846someobsession'
 import A6_CHAPTER2847STAMPEDING from '@/components/46_chapter2847stampeding'
 import A7_CHAPTER2848SUPREMEBLOOD from '@/components/47_chapter2848supremeblood'
 import A8_CHAPTER2849ONETIMEREDEMPTION from '@/components/48_chapter2849onetimeredemption'
 import A9_CHAPTER2850VENGEANCE from '@/components/49_chapter2850vengeance'
 import A0_CHAPTER2851WHOSGONNAFCKWHO from '@/components/50_chapter2851whosgonnafckwho'
 import A1_CHAPTER2852HEHADCONFIDENCE from '@/components/51_chapter2852hehadconfidence'
 import A2_CHAPTER2853THELONGRIVEROFDESTINY from '@/components/52_chapter2853thelongriverofdestiny'
 import A3_CHAPTER2854WHATKINDOFEYES from '@/components/53_chapter2854whatkindofeyes'
 import A4_CHAPTER2855FINALLY from '@/components/54_chapter2855finally'
 import A5_CHAPTER2856ITSNOTINMYEYES from '@/components/55_chapter2856itsnotinmyeyes'
 import A6_CHAPTER2857PLAYTHEPIGTOEATTHETIGER from '@/components/56_chapter2857playthepigtoeatthetiger'
 import A7_CHAPTER2858MADAMEWANGZHAI from '@/components/57_chapter2858madamewangzhai'
 import A8_CHAPTER2859HEISVERYAGGRIEVED from '@/components/58_chapter2859heisveryaggrieved'
 import A9_CHAPTER2860AHARDFIGHT from '@/components/59_chapter2860ahardfight'
 import A0_CHAPTER2861YOUCANBITEPEOPLE from '@/components/60_chapter2861youcanbitepeople'
 import A1_CHAPTER2862ALITTLEAWKWARD from '@/components/61_chapter2862alittleawkward'
 import A2_CHAPTER2863DISPELAWKWARDNESS from '@/components/62_chapter2863dispelawkwardness'
 import A3_CHAPTER2864HAVEAGOODTIME from '@/components/63_chapter2864haveagoodtime'
 import A4_CHAPTER2865MANYLIKE from '@/components/64_chapter2865manylike'
 import A5_CHAPTER2866IFYOUWANTTOPOKEMEITSYOU from '@/components/65_chapter2866ifyouwanttopokemeitsyou'
 import A6_CHAPTER2867NORESERVE from '@/components/66_chapter2867noreserve'
 import A7_CHAPTER2868HEISTHEEXCEPTION from '@/components/67_chapter2868heistheexception'
 import A8_CHAPTER2869SHEDOESNOTTAKETHEBLAME from '@/components/68_chapter2869shedoesnottaketheblame'
 import A9_CHAPTER2870VERYBORING from '@/components/69_chapter2870veryboring'
 import A0_CHAPTER2871SHEISVERYANGRY from '@/components/70_chapter2871sheisveryangry'
 import A1_CHAPTER2872YOUDRIVEMEAWAY from '@/components/71_chapter2872youdrivemeaway'
 import A2_CHAPTER2873DONOTBESTINGY from '@/components/72_chapter2873donotbestingy'
 import A3_CHAPTER2874WHILEHEWASFOOLINGAROUND from '@/components/73_chapter2874whilehewasfoolingaround'
 import A4_CHAPTER2875YOUCANTAFFORDTOPLAY from '@/components/74_chapter2875youcantaffordtoplay'
 import A5_CHAPTER2876ITSMYFAULT from '@/components/75_chapter2876itsmyfault'
 import A6_CHAPTER2877IDONTLIKEYOU from '@/components/76_chapter2877idontlikeyou'
 import A7_CHAPTER2878KEEPHERINSIGHT from '@/components/77_chapter2878keepherinsight'
 import A8_CHAPTER2879CROWNOFSUPREMACY from '@/components/78_chapter2879crownofsupremacy'
 import A9_CHAPTER2880HALFSTEPMARTIALSAINT from '@/components/79_chapter2880halfstepmartialsaint'
 import A0_CHAPTER2881MASTERISHERE from '@/components/80_chapter2881masterishere'
 import A1_CHAPTER2882PURSUEDIFFERENCE from '@/components/81_chapter2882pursuedifference'
 import A2_CHAPTER2883NOMATTERWHEREITISITSGOOD from '@/components/82_chapter2883nomatterwhereitisitsgood'
 import A3_CHAPTER2884SHEGOTOVERIT from '@/components/83_chapter2884shegotoverit'
 import A4_CHAPTER2885TARGETAPPEARANCE from '@/components/84_chapter2885targetappearance'
 import A5_CHAPTER2886LOCATED from '@/components/85_chapter2886located'
 import A6_CHAPTER2887VIOLENTATTACK from '@/components/86_chapter2887violentattack'
 import A7_CHAPTER2888GREATTERROR from '@/components/87_chapter2888greatterror'
 import A8_CHAPTER2889THELONGRIVEROFDESTINY from '@/components/88_chapter2889thelongriverofdestiny'
 import A9_CHAPTER2890ASHANDSMOKE from '@/components/89_chapter2890ashandsmoke'
 import A0_CHAPTER2891NEWTITLE from '@/components/90_chapter2891newtitle'
 import A1_CHAPTER2892THEROADTOCONTENTION from '@/components/91_chapter2892theroadtocontention'
 import A2_CHAPTER2893TRODONTHETAIL from '@/components/92_chapter2893trodonthetail'
 import A3_CHAPTER2894HOWINFURIATING from '@/components/93_chapter2894howinfuriating'
 import A4_CHAPTER2895SHEISASUBSIDIARY from '@/components/94_chapter2895sheisasubsidiary'
 import A5_CHAPTER2896DONTTOUCHME from '@/components/95_chapter2896donttouchme'
 import A6_CHAPTER2897SOVEREIGNREALM from '@/components/96_chapter2897sovereignrealm'
 import A7_CHAPTER2898IMMORTALANDINDESTRUCTIBLE from '@/components/97_chapter2898immortalandindestructible'
 import A8_CHAPTER2899DESTRUCTIVEPURPLEGAS from '@/components/98_chapter2899destructivepurplegas'
 import A9_CHAPTER2900THEONLYONEINTHEWORLD from '@/components/99_chapter2900theonlyoneintheworld'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter2801theworldishardtopredict",
 			"name" : "0_chapter2801theworldishardtopredict",
 			"component" : A_CHAPTER2801THEWORLDISHARDTOPREDICT
 		},
 		{
 			"path" : "/1_chapter2802blessedbymisfortune",
 			"name" : "1_chapter2802blessedbymisfortune",
 			"component" : A_CHAPTER2802BLESSEDBYMISFORTUNE
 		},
 		{
 			"path" : "/2_chapter2803severheartmeridian",
 			"name" : "2_chapter2803severheartmeridian",
 			"component" : A_CHAPTER2803SEVERHEARTMERIDIAN
 		},
 		{
 			"path" : "/3_chapter2804apoplexy",
 			"name" : "3_chapter2804apoplexy",
 			"component" : A_CHAPTER2804APOPLEXY
 		},
 		{
 			"path" : "/4_chapter2805youarenoteligible",
 			"name" : "4_chapter2805youarenoteligible",
 			"component" : A_CHAPTER2805YOUARENOTELIGIBLE
 		},
 		{
 			"path" : "/5_chapter2806whoaretheseants",
 			"name" : "5_chapter2806whoaretheseants",
 			"component" : A_CHAPTER2806WHOARETHESEANTS
 		},
 		{
 			"path" : "/6_chapter2807beabletostandstill",
 			"name" : "6_chapter2807beabletostandstill",
 			"component" : A_CHAPTER2807BEABLETOSTANDSTILL
 		},
 		{
 			"path" : "/7_chapter2808silverelephanthammer",
 			"name" : "7_chapter2808silverelephanthammer",
 			"component" : A_CHAPTER2808SILVERELEPHANTHAMMER
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js